import React from "react";
import { TvlParticipant } from "./style";

function PoolTvlParticipants({ large, label1, lable2, value1, value2 }) {
  return (
    <TvlParticipant className="flex height1" large={large}>
      <div className="tvlParticipants">
        <p className="p1">{label1}</p>
        <p className="p2">{value1 ? value1 : 0}</p>
      </div>
      <div className="tvlParticipants">
        <p className="p1">{lable2}</p>
        <p className="p2">{value2 ? value2 : 0}</p>
      </div>
    </TvlParticipant>
  );
}

export default PoolTvlParticipants;
